import React from 'react';
export var FileUploaderControlContext = /*#__PURE__*/React.createContext({});